import React from "react";
import { Link } from "react-router-dom";
import './LandingCard.css';

const LandingCard = (props) => {

  const handleClickCard = (event) => {
    if (props.disabled) {
      event?.preventDefault();
      return;
    }

    if (!props?.disabled && props?.onClick) {
      props?.onClick();
    }
  };

  return (
    props.redirectUrl?
    <a
      href={props.disabled ? "#" : props.url}
      target="_blank"
      style={{
        textDecoration: "none",
        color: "#000",
        fontWeight: "700",
        fontSize: "17px",
        pointerEvents: props.disabled ? "none" : "auto",
        cursor: props.disabled ? "not-allowed" : "pointer",
      }}
      // onClick={handleClickCard}
    >
      <div className={`card-div ${props.title === "Lead Time Analytics" ? "leadTime" : props.title === "Contract Data Update" ? "ContractData" : props.title === "Supplier Collaboration" ? "SupplierCollaboration" : props.title === "PO Management" ? "POManagement" : props.title === "GRPT Analytics" ? "GRPTAnalytics" : ""}`} style={{ border: props?.disabled ? "1px solid #bcbcbc" : "2px solid #000000" }}>
        <p style={{ color: props?.disabled ? "#bcbcbc" : props.color ? props.color : "#000000" }}>{props.title}</p>
      </div>
    </a>
    :
    <Link
      to={props.disabled ? "#" : props.url}
      style={{
        textDecoration: "none",
        color: "#000",
        fontWeight: "700",
        fontSize: "17px",
        pointerEvents: props.disabled ? "none" : "auto",
        cursor: props.disabled ? "not-allowed" : "pointer",
      }}
      onClick={handleClickCard}
    >
      <div className={`card-div ${props.title === "Lead Time Analytics" ? "leadTime" : props.title === "Contract Data Update" ? "ContractData" : props.title === "Supplier Collaboration" ? "SupplierCollaboration" : props.title === "PO Management" ? "POManagement" : props.title === "GRPT Analytics" ? "GRPTAnalytics" : ""}`} style={{ border: props?.disabled ? "1px solid #bcbcbc" : "2px solid #000000" }}>
        <p style={{ color: props?.disabled ? "#bcbcbc" : props.color ? props.color : "#000000" }}>{props.title}</p>
      </div>
    </Link>
  );
};

export default LandingCard;
